import { Container, Stack, Button } from "@mui/material";

const G0211FoodAdditive = () => {
  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">
              <Container maxWidth="lg">
                <Stack spacing={2}>
                  <h1>食品添加物</h1>

                  <Button href="./G0217EuQuarantineList"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    食品添加物検疫
                  </Button>

                  <Button href="./G0212EuAdditiveList"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    添加物一覧
                  </Button>

                  <Button href="./G0213EuFoodCategoryList"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    食品カテゴリー一覧
                  </Button>

                  <Button href="./G0214EuFootnoteList"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    脚注
                  </Button>

                  <Button href="./G0215EuFoodAdditiveList"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    食品添加物
                  </Button>

                  <Button href="./G0216EuCombinationList"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    組み合わせ
                  </Button>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default G0211FoodAdditive;